module.exports = __webpack_public_path__ + "img/0130.c8fec0cd.png";